import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SubDailyReportsPage } from '@/features/subcontracts/daily-reports-page';

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/daily-reports')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const { date } = Route.useSearch();
  return <SubDailyReportsPage projectId={projectId} date={date} />;
}
